import { useTranslation } from "react-i18next";
import DynamicForm from "../../../../../../../yoello-lib/modules/dynamicForms/DynamicForms";
import SearchEmailForm from "./SearchEmail.form";
import { Button, Grid } from "@material-ui/core";
import { useStyles } from "../style";
import ICommonFormProps from "../../../../../../../yoello-lib/modules/dynamicForms/interfaces/ICommonFormProps";
import { useState } from "react";

interface ISearchEmail extends ICommonFormProps {
  userStatus: boolean;
  onClear: Function;
  onSearch: Function;
}
const SearchEmail = (props: ISearchEmail) => {
  const [isClear, setIsClear] = useState(false);
  const { t } = useTranslation();
  const classes = useStyles();

  const handleClear = () => {
    setIsClear(true);
    props.formProps?.onClear();
  };
  const handleSubmit = (data: any) => {
    if (props.setValue) {
      props.setValue("email", data.email);
    }
    props.formProps?.onSearch(data);
    setIsClear(false);
  };
  return (
    <Grid container className={classes.searchUser}>
      <Grid item xs={12} className="header">
        <Grid item xs={6}>
          {t("checkUserStatus.form.emailAddress")}
        </Grid>
        {props.formProps?.userStatus !== undefined && (
          <Grid item xs={6} className="clearButtonContainer">
            <Button type="reset" onClick={handleClear} variant="contained">
              {t("checkUserStatus.form.clearEmail")}
            </Button>
          </Grid>
        )}
      </Grid>

      <Grid item xs={12} className="formContainer">
        <DynamicForm
          onHandleSubmit={handleSubmit}
          formRows={SearchEmailForm(
            t,
            props.formProps?.isLoading,
            props.formProps?.userStatus,
            isClear,
            props.formProps?.error
          )}
          formKeyName="search-email"
          useFormOptions={{
            reValidateMode: "onSubmit",
          }}
        />
      </Grid>
    </Grid>
  );
};

export default SearchEmail;
